module.exports = __webpack_public_path__ + "static/line1_6-85445797381bc6d12e359d6ac00b2d48.jpg";